import React, { useEffect, useState } from 'react'
import Library from './Library'
import UrlCard from '../../Post/UrlCard'
import './Library.css'

function Articles(props) {
    const [data, setData] = useState([]);
    useEffect(() => {
        fetch("https://recruitingmonk-v2.azurewebsites.net/library/alllibrary", {

        })

            .then((res) => res.json())
            .then((result) => {
                console.log(result);
                if(result.success)
                    setData(result.library);

            }).catch((err) => {
                console.log(err)
            })
    }, []);
    return (
        <div className="LibCards">
            <Library content='Articles' />
            <div className="Cards">
                {data && data.map((item) => {
                    return <UrlCard key={item._id} title={item.text} author={`Contributor: ${item.name}`} comments={item.comments.length} views="45" votes={item.likes.length} className="card" />
                })}

            </div>
        </div>
    )
}

export default Articles